import { render, staticRenderFns } from "./TwilioOverviewPanel.vue?vue&type=template&id=a7ac95c2&scoped=true"
import script from "./TwilioOverviewPanel.vue?vue&type=script&lang=js"
export * from "./TwilioOverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./TwilioOverviewPanel.vue?vue&type=style&index=0&id=a7ac95c2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ac95c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ac95c2')) {
      api.createRecord('a7ac95c2', component.options)
    } else {
      api.reload('a7ac95c2', component.options)
    }
    module.hot.accept("./TwilioOverviewPanel.vue?vue&type=template&id=a7ac95c2&scoped=true", function () {
      api.rerender('a7ac95c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/TwilioOverviewPanel.vue"
export default component.exports